import { useUi } from "../../stores/ui";

export function PreferencesTab() {
  const theme = useUi((s) => s.theme);
  const setTheme = useUi((s) => s.setTheme);

  return (
    <div className="max-w-xl space-y-4">
      <h2 className="text-xl font-medium">Preferences</h2>
      <div className="flex items-center justify-between border-t border-border py-3 text-sm">
        <div>
          <div>Theme</div>
          <div className="text-[11px] text-text-dim">
            Follow your system, or pick one explicitly
          </div>
        </div>
        <select
          value={theme}
          onChange={(e) => setTheme(e.target.value as "auto" | "light" | "dark")}
          className="rounded-md border border-border bg-white/5 px-3 py-1 text-sm"
        >
          <option value="auto">Auto (system)</option>
          <option value="light">Light</option>
          <option value="dark">Dark</option>
        </select>
      </div>
    </div>
  );
}
